const FA_DIGITS = '۰۱۲۳۴۵۶۷۸۹';

const toPersianDigits = value => String(value ?? '')
  .replace(/[0-9]/g, digit => FA_DIGITS[Number(digit)])
  .replace(/[٠-٩]/g, digit => FA_DIGITS['٠١٢٣٤٥٦٧٨٩'.indexOf(digit)]);

export default function VehiclePlate({ vehicle, variant = 'card' }) {
  const hasPlate = vehicle && (vehicle.plate1 || vehicle.plate2 || vehicle.plate3 || vehicle.plateEnd);
  if (!hasPlate) return <small className="service-one-plate__empty">پلاک ثبت نشده</small>;

  return <span className={`service-one-plate service-one-plate--${variant}`} dir="ltr" aria-label={`پلاک ${vehicle.plate1} ${vehicle.plate3} ${vehicle.plate2} ایران ${vehicle.plateEnd}`}>
    <span className="service-one-plate__iran">IR</span>
    <span className="service-one-plate__main">
      <b>{toPersianDigits(vehicle.plate1)}</b>
      <b className="service-one-plate__letter">{vehicle.plate3}</b>
      <b>{toPersianDigits(vehicle.plate2)}</b>
    </span>
    <span className="service-one-plate__end"><small>ایران</small><b>{toPersianDigits(vehicle.plateEnd)}</b></span>
  </span>;
}
